var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchievementsbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 890,
    height: 847,
    viewBox: "0 0 890 847",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M442.553 5.85325L99.8547 163.539C95.8485 165.382 92.8675 168.932 91.8285 173.222L4.89546 532.171C3.86382 536.43 4.87599 540.903 7.63021 544.311L242.007 834.33C244.742 837.714 248.874 839.659 253.222 839.688L632.39 842.26C636.783 842.29 640.988 840.362 643.798 836.983L882.204 550.298C885.021 546.911 886.129 542.428 885.152 538.128L803.357 177.965C802.392 173.715 799.511 170.175 795.58 168.301L455.056 5.92586C451.114 4.04622 446.52 4.02798 442.553 5.85325Z",
    stroke: "url(#paint0_linear_1067_29916)",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M442.727 135.279L207.653 243.602C204.521 245.045 202.182 247.828 201.366 251.202L141.734 497.784C140.924 501.136 141.72 504.656 143.883 507.337L304.654 706.567C306.801 709.228 310.04 710.751 313.439 710.774L573.529 712.541C576.962 712.564 580.251 711.056 582.452 708.406L745.987 511.465C748.194 508.807 749.067 505.283 748.299 501.897L692.192 254.48C691.433 251.133 689.168 248.352 686.089 246.882L452.507 135.337C449.42 133.863 445.827 133.85 442.727 135.279Z",
    stroke: "url(#paint1_linear_1067_29916)",
    strokeWidth: 9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1067_29916",
    x1: -54.8892,
    y1: -91.7981,
    x2: 878.104,
    y2: 1042.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F6CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7360C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1067_29916",
    x1: 102.099,
    y1: 69.4751,
    x2: 743.205,
    y2: 847.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F6CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7360C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementsbg);
export default __webpack_public_path__ + "static/media/Achievementsbg.08d22979670363e542a8b3bbba71c50c.svg";
export { ForwardRef as ReactComponent };